	import { Component, NationalHolidayService, BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";


	export default abstract class  NationalHolidayDetailBase extends BaseTLDetailComponent {

		nationalHolidayService: NationalHolidayService = new NationalHolidayService();

		formData = {
			id: 0,
			name: '',
			dayOfHoliday: '',
			validFrom: '',
			validTo: '',
			idCountry: 0
		};

		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('nationalHoliday.messageNew').toString(), this.$t('nationalHoliday.messageEdit').toString(), this.$t('nationalHoliday.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.nationalHolidayService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.dayOfHoliday = response.data.dayOfHoliday.substring(0, 10);
			this.formData.validFrom = response.data.validFrom != null ? response.data.validFrom.substring(0, 10) : '';
			this.formData.validTo = response.data.validTo != null ? response.data.validTo.substring(0, 10) : '';
			this.formData.idCountry = response.data.idCountry;
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.idCountry = response.data.idCountry;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			this.prepareFormData();
			return this.nationalHolidayService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {		
			this.prepareFormData();
			this.formData.idCountry = Number(this.$router.currentRoute.query.idCountry);
			return this.nationalHolidayService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.nationalHolidayService.delete(this.objectId);
		}

		prepareFormData() {
			if (this.formData.validFrom == '') {
				delete this.formData.validFrom;
			}
			if (this.formData.validTo == '') {
				delete this.formData.validTo;
			}
		}

		vIsCorrectName: boolean = true;
		vIsCorrectDate: boolean = true;
		vIsMinDate: boolean = true;
		vIsMaxDate: boolean = true;

		protected validateBase() {
			return !(this.vIsCorrectName && this.vIsCorrectDate && this.vIsMinDate && this.vIsMaxDate);
		}

		//bohužel to jinak nešlo
		requiredDateTo() {
			if (this.formData.validTo == "" || this.formData.validTo == undefined) {
				this.vIsMaxDate = true;
				return false;
			}
			else {
				return true;
			}
		}

		requiredDateFrom() {
			if (this.formData.validFrom == "" || this.formData.validFrom == undefined) {
				this.vIsMinDate = true;
				return false;
			}
			else {
				return true;
			}
		}

		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}
		protected isCorrectDateBase(value: any) {
			this.vIsCorrectDate = value;
		}

		protected isCorrectMinDateBase(value: any) {
			this.vIsMinDate = value;
		}

		protected isCorrectMaxDateBase(value: any) {
			this.vIsMaxDate = value;
		}
	}
